import welcomeSvg from '../../assets/images/welcome.svg';

const TOUR_REFERAL_CONTENT = [
  {
    content: <img src={welcomeSvg} alt="step" style={{ marginRight: '8px' }} />,
    placement: 'center',
    target: 'body'
  },
  {
    title: 'Search & Filter',
    content: 'Use criteria based filter and search to view referred merchant’s activation status',
    placement: 'right',
    target: '.ebz-filters-btn'
  },
  {
    title: 'Export',
    content: 'Export customized data for tracking the merchant’s activation status',
    placement: 'bottom',
    target: '.export-btn'
  },
  {
    title: 'Create Lead',
    content: 'Add prospective leads and schedule a demo for them',
    placement: 'bottom',
    target: '.create-lead'
  },
  {
    content: (
      <div>
        <h2>End</h2>
      </div>
    ),
    placement: 'center',
    target: 'body'
  }
];

const PRODUCT_APP_TYPE = [
  {
    label: 'Payment Gateway',
    value: 'pay_easebuzz_allowed'
  },
  {
    label: 'Payment Link',
    value: 'easepay_allowed'
  },
  {
    label: 'Form & Feesbuzz',
    value: 'edu_allowed'
  },
  {
    label: 'WIRE',
    value: 'wire_allowed'
  }
];

const SUBMERCHANT_BUSINESS_ENTITY = [
  {
    value: 'Individual / Freelancers',
    label: 'Individual / Freelancers'
  },
  {
    value: 'Society / Trust – Education',
    label: 'Society / Trust – Education'
  },
  {
    value: 'HUF (Hindu Undivided Family)',
    label: 'HUF (Hindu Undivided Family)'
  },
  {
    value: 'Limited Liability Partnership',
    label: 'Limited Liability Partnership'
  },
  {
    value: 'Partnership Firm',
    label: 'Partnership Firm'
  },
  {
    value: 'Sole Proprietor',
    label: 'Sole Proprietor'
  },
  {
    value: 'Private Ltd / Public Ltd / OPC',
    label: 'Private Ltd / Public Ltd / OPC'
  },
  {
    value: 'Trust / NGO – Donations',
    label: 'Trust / NGO – Donations'
  },
  {
    value: 'Government Entity',
    label: 'Government Entity'
  },
  {
    value: 'Co-operative Credit Society / JV / AOP',
    label: 'Co-operative Credit Society / JV / AOP'
  }
];

const SUBMERCHANT_STATE = [
  { label: 'Andaman and Nicobar Islands', value: 'Andaman and Nicobar Islands' },
  { label: 'Andhra Pradesh', value: 'Andhra Pradesh' },
  { label: 'Arunachal Pradesh', value: 'Arunachal Pradesh' },
  { label: 'Assam', value: 'Assam' },
  { label: 'Bihar', value: 'Bihar' },
  { label: 'Chandigarh', value: 'Chandigarh' },
  { label: 'Chhattisgarh', value: 'Chhattisgarh' },
  { label: 'Dadra and Nagar Haveli', value: 'Dadra and Nagar Haveli' },
  { label: 'Daman and Diu', value: 'Daman and Diu' },
  { label: 'Delhi', value: 'Delhi' },
  { label: 'Goa', value: 'Goa' },
  { label: 'Gujarat', value: 'Gujarat' },
  { label: 'Haryana', value: 'Haryana' },
  { label: 'Himachal Pradesh', value: 'Himachal Pradesh' },
  { label: 'Jammu and Kashmir', value: 'Jammu and Kashmir' },
  { label: 'Jharkhand', value: 'Jharkhand' },
  { label: 'Karnataka', value: 'Karnataka' },
  { label: 'Kerala', value: 'Kerala' },
  { label: 'Ladakh', value: 'Ladakh' },
  { label: 'Lakshadweep', value: 'Lakshadweep' },
  { label: 'Madhya Pradesh', value: 'Madhya Pradesh' },
  { label: 'Maharashtra', value: 'Maharashtra' },
  { label: 'Manipur', value: 'Manipur' },
  { label: 'Meghalaya', value: 'Meghalaya' },
  { label: 'Mizoram', value: 'Mizoram' },
  { label: 'Nagaland', value: 'Nagaland' },
  { label: 'Odisha', value: 'Odisha' },
  { label: 'Puducherry', value: 'Puducherry' },
  { label: 'Punjab', value: 'Punjab' },
  { label: 'Rajasthan', value: 'Rajasthan' },
  { label: 'Sikkim', value: 'Sikkim' },
  { label: 'Tamil Nadu', value: 'Tamil Nadu' },
  { label: 'Telangana', value: 'Telangana' },
  { label: 'Tripura', value: 'Tripura' },
  { label: 'Uttar Pradesh', value: 'Uttar Pradesh' },
  { label: 'Uttarakhand', value: 'Uttarakhand' },
  { label: 'West Bengal', value: 'West Bengal' }
];

export { TOUR_REFERAL_CONTENT, PRODUCT_APP_TYPE, SUBMERCHANT_BUSINESS_ENTITY, SUBMERCHANT_STATE };
